import { defineMessages } from 'react-intl';

export default defineMessages({
    policyNumber: {
        id: 'twia.gateway.views.policy-landing.PolicyNumber',
        defaultMessage: 'Policy Number'
    }
});
